import images from "../../../images";

const inspoList = [
    {
        title: "onio.club",
        subtitle: "https://onio.club/",
        thumbnail: images.oniocafe.url,
        url: "https://onio.club/"
    },
    {
        title: "mushmallow",
        subtitle: "https://mushmallow.neocities.org/",
        thumbnail: images.mushmallow.url,
        url: "https://mushmallow.neocities.org/"
    },
    {
        title: "olliveen",
        subtitle: "https://olliveen.neocities.org/",
        thumbnail: images.olliveen.url,
        url: "https://olliveen.neocities.org/"
    },
    {
        title: "https://hillhouse.neocities.org/",
        subtitle: "https://hillhouse.neocities.org/",
        thumbnail: images.hillhouse.url,
        url: "https://hillhouse.neocities.org/"
    }
]

export default inspoList;